import { Injectable } from '@angular/core';
import { cleanUpSpaces, exportToCsv, exportToCsvWithColor, exportToExcel, getBrokersList, isDecimal, levelOfServiceName, toTitleCase } from 'src/app/utils/utils.common';
import * as moment from 'moment-timezone';
import { CamelCasePipe } from 'src/app/pipe/camelcase.filter/camelcase.filter.pipe';
// import { CamelCasePipe } from 'src/app/pipe/camelcase.filter/camelcase.filter.pipe';

@Injectable({
  providedIn: 'root'
})
export class CsvService {

  constructor(
    private capitalize: CamelCasePipe
  ) { }

  generateDriverReport(data) {
    const { date, trips, corporate, driver, vehicle, timezone } = data;
    const myTrips = JSON.parse(JSON.stringify(trips));

    const table = [
      [
        "Driver",
        "Account Code",
        "Auth Num",
        "Schedule Time",
        "Appointment Time",
        "Will Call",
        "LOA",
        "Passenger's Phone #",
        "Passenger's First Name",
        "Passenger's Last Name",
        "Pickup Name",
        "PU Phone #",
        "PU Address",
        "Dropoff Name",
        "Dropoff Phone #",
        "Dropoff Address",
        "Rider Comments",
      ]];

    let privatePay = myTrips.filter(trip => {
      if (corporate && corporate.length ) {
        // if (trip.jobType !== 'cooperate') {
        //   return false;
        // }
        if (trip.cooperate && !corporate.includes(trip.cooperate)) {
          return false;
        }
      }
      if (driver && driver.length) {
        if (trip.driver && !driver.includes(trip.driver._id)) {
          return false;
        }
      }
      // if (vehicle) {
      //   if (trip.tripRequirement !== vehicle) {
      //     return false;
      //   }
      // }
      return true;
    })

    const driverWise = {};
    for (const trip of privatePay) {
      if (trip.driver) {
        if (trip.driver && driverWise[trip.driver.displayName]) {
          driverWise[trip.driver.displayName].push(trip);
        } else {
          driverWise[trip.driver.displayName] = [trip];
        }
      } else {
        if (driverWise["unassigned"]) {
          driverWise["unassigned"].push(trip);
        } else {
          driverWise["unassigned"] = [trip];
        }
      }

    }


    var sortedObject = {};
    var sortedKeys = Object.keys(driverWise).sort();
    for (var key of sortedKeys) {
      sortedObject[key] = driverWise[key];
    }

    for (const driverId in sortedObject) {
      for (const trip of driverWise[driverId]) {

        let forTrip;
        if (trip.jobType !== 'cooperate') {
          forTrip = trip.companyType === "" ? "Cab Dispatch" : getBrokersList[trip.companyType];
        }

        if (trip.jobType === 'cooperate') {
          forTrip = trip.cooperate ? trip.cooperate.displayName : "N/A"
        }

        let appointmentTime;
        if (trip.appointmentTime) {
          appointmentTime = moment(trip.appointmentTime).tz(timezone).format('MM/DD/YYYY HHmm');
        }
        let scheduleTime;
        if (trip.scheduleTime) {
          scheduleTime = moment(trip.scheduleTime).tz(timezone).format('MM/DD/YYYY HHmm');
        }
        let name = trip.priorityClient.displayName.split(' ');


        const t = [
          trip.driver ? trip.driver.displayName : '',
          forTrip,
          trip.tripId,
          scheduleTime,
          appointmentTime,
          scheduleTime.split(" ")[1] >= "22" ? "Y" : "N",
          this.checkCarType(trip.tripRequirement),
          trip.priorityClient.contactNumber,
          name[0], //"Passenger's First Name",
          name[1] ? name[1] : '', //"Passenger's Last Name",
          trip.originAddressAdditional && trip.originAddressAdditional.place ? trip.originAddressAdditional.place : '',
          trip.originAddressAdditional && trip.originAddressAdditional.phone ? trip.originAddressAdditional.phone : '',
          trip.jobOriginAddress, //"Passenger's Address",,
          trip.destinationAddressAdditional && trip.destinationAddressAdditional.place ? trip.destinationAddressAdditional.place : '',
          trip.destinationAddressAdditional && trip.destinationAddressAdditional.phone ? trip.destinationAddressAdditional.phone : '',
          trip.jobDestinationAddress, //"Passenger's Address",
          trip.note,
        ]
        table.push(t);
      }
    }


    exportToCsv(`drivers-manifest-${date}.csv`, table);
    // this.excelService.setCombinedFirstRowWithFontSize(date, table, `drivers-report-${moment().format("MM-DD-YYYY")}`);
  }

  checkCarType(car) {
    const vehicles = {
      'BW': 'SUV',
      'SUV': 'SUV',
      'Premium': 'P',
      'Stretcher': 'GUR',
      'S': 'GUR',
      'BLS': 'GUR',
      'BSTR': 'GUR',
      'VS': 'GUR',
      'LIV': 'A',
      'AMB': 'A',
      'Ambulatory': 'A',
      'Wheelchair': 'WC',
      'W': 'WC',
      'WAV': 'WC',
      'WPCA': 'WC',
      'WMAV': 'WC',
      'A': 'A',
      'L': 'A',
      'ADD': 'A',
      'AMAV': 'A',
      'Standard': 'A',
      '': 'A'
    };

    if (!vehicles[car]) return car;
    return vehicles[car];
  }
  generateCorporateReport(data) {
    const { trips, corporate, driver, vehicle, payor, timezone } = data;

    const table = [[
      "Passenger's First Name",
      "Passenger's Last Name",
      "Passenger DOB",
      "Schedule Time",
      "Appointment Time",
      "Gender",
      "Weight",
      "Passenger's Phone #",
      "Passenger's 2-nd Phone#",
      "Passenger's Address",
      "Email	On Hold (Y/N)",
      "Corporate Name",
      "Payor",
      "Active Payer (Y/N)"
    ]];

    let filterdataList = trips.filter(trip => {

      if (corporate) {
        if (trip.jobType !== 'cooperate') {
          return false;
        }
        if (trip.cooperate && trip.cooperate._id.toString() !== corporate) {
          return false;
        }

      }

      if (payor) {
        if (!trip.payor || trip.payor.toLowerCase() !== payor.toLowerCase()) {
          return false;
        }
      }

      if (driver) {
        if (trip.driver && trip.driver._id.toString() !== driver) {
          return false;
        }
      }

      if (vehicle) {
        if (trip.tripRequirement !== vehicle) {
          return false;
        }
      }
      return true;
    })


    for (const trip of filterdataList) {

      let forTrip;
      if (trip.jobType === 'cooperate') {
        forTrip = trip.cooperate ? trip.cooperate.displayName : "N/A"
      }

      let appointmentTime;
      if (trip.appointmentTime) {
        appointmentTime = moment(trip.appointmentTime).tz(timezone).format('MM/DD/YYYY HHmm');
      }
      let scheduleTime;
      if (trip.scheduleTime) {
        scheduleTime = moment(trip.scheduleTime).tz(timezone).format('MM/DD/YYYY HHmm');
      }
      let name = trip.priorityClient.displayName.split(' ');
      const t = [
        name[0], //"Passenger's First Name",
        name[1] ? name[1] : 'N/A', //"Passenger's Last Name",
        trip.dob, //"Passenger DOB",
        scheduleTime,
        appointmentTime,
        "---", //"Gender",
        trip.weight, //"Weight",
        trip.priorityClient.cellPhone, //"Passenger's Phone #",
        trip.priorityClient.contactNumber, //"Passenger's 2-nd Phone#",
        trip.jobOriginAddress, //"Passenger's Address",
        trip.priorityClient.email, //"Email	On Hold (Y/N)",
        forTrip, //"Payer",
        trip.payor, //"Payor",
        "TRUE", //"Active Payer (Y/N)",
      ]
      table.push(t);
    }
    exportToCsv(`payor-report-${moment().format("MM-DD-YYYY")}.csv`, table);
  }

  generateScoreReport(data) {
    const { date, scores } = data;
    const table = [
      [
        "Driver",
        "Completed",
        "Early",
        "On Time",
        "Late",
        "Early Time Score",
        "On Time Score",
        "Late Time Score"
      ]];

    scores.forEach(score => {
      table.push([
        score.driver.displayName,
        score.total,
        score.earlyTrips,
        score.onTimeTrips,
        score.lateTrips,
        isDecimal(score.percentageEarly) ? score.percentageEarly.toFixed(2) + '%' : score.percentageEarly + '%',
        isDecimal(score.percentageOnTime) ? score.percentageOnTime.toFixed(2) + '%' : score.percentageOnTime + '%',
        isDecimal(score.percentageLate) ? score.percentageLate.toFixed(2) + '%' : score.percentageLate + '%'
      ]);
    });
    exportToCsv(`driver-score-${date}.csv`, table);
  }

  multiSheet(data, dateRange, driver) {
    if (data && driver && dateRange) {
      const table1 = [
        [
          'Date Range',
          'Driver Name',
          'Total Working Hours',
          'Total Break Hours',
          'Total Days',
        ]
      ]

      let t = [
        moment(dateRange.startDate).format("MM/DD/YYYY") + '-' + moment(dateRange.endDate).format("MM/DD/YYYY"),
        driver.displayName,
        this.viewHourFormat(data.workTimeInMillis),
        this.viewHourFormat(data.breakTimeInMillis),
        data.totalDays,
      ]
      table1.push(t)


      const table2 = [
        [
          'Date',
          'Time In',
          'Time Out',
          'Break Hours',
          'Working Hours',
        ]
      ]
      if (data.jobs) {
        for (let item of data.jobs) {
          if (item) {
            let t = [
              moment(item.checkin).format("MM/DD/YYYY") + '-' + moment(item.checkout).format("MM/DD/YYYY"),
              moment(item.checkin).format("HHmm"),
              moment(item.checkout).format("HHmm"),
              this.viewHourFormat(item.breakTimeInMillis),
              this.viewHourFormat(item.workTimeInMillis),
            ]
            table2.push(t)
          }
        }
      }
      const sheets = {
        "Time In Time Out Report": table1,
        "History": table2,
      };
      exportToExcel("Driver-History.xlsx", sheets);
    }
  }

  generateTripItineraryReport(trips, date, timezone, preCooperates, preLevelOfServices, preSpaceTypes, preServiceAreas) {

    const table = [
      [
        "trip_id",
        "trip_status",
        "created_at",
        "service_area",
        "pu_address",
        "pu_date",
        "do_address",
        "do_date",
        "actual_miles",
        "funding_source",
        "source",
        "track_id",
        "los",
        "space_type",
        "ipa_number",
        "passenger_name",
        "phone_number",
        "cell_phone",
        "client_id",
        "insurance_id",
        "dob",
        "weight",
        "driver_name",
        "odometer_begin",
        "odometer_start",
        "odometer_end",
        "dead_miles",
        "dead_minutes",
        "wait_time",
        "trip_miles",
        "trip_time",
        "total_trip_miles",
        "total_trip_time",
        "total_trip_miles_+_dead_miles",
        "total_trip_time_+_dead_minutes",
        "driver_notes",
        "biller_notes",
        "dispatcher_notes",
        "accepted_time",
        "accepted_coords",
        "onscene_time",
        "onscene_coords",
        "started_time",
        "started_coords",
        "ended_time",
        "ended_coords",
        "finished_time",
        "finished_coords",
        "BSR",
        "change_reason"
      ]];
    trips.forEach(trip => {
      let acceptedDate, pickupDate, arrivedDate, endDate, finishDate, scheduleTime, appointmentTime, createdAt = ' ';
      if (trip.scheduleTime) {
        scheduleTime = moment(trip.scheduleTime).tz(timezone).format("MMM DD, YYYY : HH:mm");
      }
      if (trip.createdAt) {
        createdAt = moment(trip.createdAt).tz(timezone).format("MMM DD, YYYY : HH:mm");
      }
      if (trip.appointmentTime) {
        appointmentTime = moment(trip.appointmentTime).tz(timezone).format("MMM DD, YYYY : HH:mm");
      }
      if (trip.job) {
        if (trip.job.trackInfoJob) {
          if (trip.job.trackInfoJob.jobAccepted) {
            if (trip.job.trackInfoJob.jobAccepted.time) {
              acceptedDate = moment(trip.job.trackInfoJob.jobAccepted.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }
          if (trip.job.trackInfoJob.jobArrived) {
            if (trip.job.trackInfoJob.jobArrived.time) {
              pickupDate = moment(trip.job.trackInfoJob.jobArrived.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }
          if (trip.job.trackInfoJob.jobStarted) {
            if (trip.job.trackInfoJob.jobStarted.time) {
              arrivedDate = moment(trip.job.trackInfoJob.jobStarted.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }
          if (trip.job.trackInfoJob.jobCompleted) {
            if (trip.job.trackInfoJob.jobCompleted.time) {
              endDate = moment(trip.job.trackInfoJob.jobCompleted.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }

          if (trip.job.trackInfoJob.jobFinished) {
            if (trip.job.trackInfoJob.jobFinished.time) {
              finishDate = moment(trip.job.trackInfoJob.jobFinished.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }

        }

      }

      let data = [
        trip.tripId ? trip.tripId : ' ',
        trip.status ? trip.status : ' ',
        createdAt ? createdAt : ' ',
        preServiceAreas[trip.serviceArea] ? preServiceAreas[trip.serviceArea].name : ' ',
        trip.jobOriginAddress ? trip.jobOriginAddress : ' ',
        scheduleTime ? scheduleTime : ' ',
        trip.jobDestinationAddress ? trip.jobDestinationAddress : ' ',
        appointmentTime ? appointmentTime : ' ',
        trip.milage ? trip.milage : ' ',
        preCooperates[trip.cooperate] ? preCooperates[trip.cooperate].displayName : ' ',
        trip.rawId ? "Parsed" : "Manual",
        trip.trackId ? trip.trackId : ' ',
        preLevelOfServices && preLevelOfServices[trip.los] ? preLevelOfServices[trip.los].title : ' ',
        preSpaceTypes && preSpaceTypes[trip.spaceType] ? preSpaceTypes[trip.spaceType].title : ' ',
        trip.ipa ? trip.ipa : ' ',
        trip.priorityClient && trip.priorityClient.displayName ? trip.priorityClient.displayName : ' ',
        trip.priorityClient && trip.priorityClient.contactNumber ? trip.priorityClient.contactNumber : ' ',
        trip.priorityClient && trip.priorityClient.cellPhone ? trip.priorityClient.cellPhone : ' ',
        trip.priorityClient && trip.priorityClient.clientId ? trip.priorityClient.clientId : ' ',
        trip.priorityClient && trip.priorityClient.memberId ? trip.priorityClient.memberId : ' ',
        trip.dob ? trip.dob : ' ',
        trip.weight ? trip.weight : ' ',
        trip.driver ? trip.driver.displayName : ' ',
        trip.job ? trip.job.odometerBegin : ' ',
        trip.job ? trip.job.odometerStart : ' ',
        trip.job ? trip.job.odometerStop : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.surchargeMiles ? trip.job.additionalInfoJob.surchargeMiles : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.surchargeMinutes ? trip.job.additionalInfoJob.surchargeMinutes : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.jobWaitTime ? trip.job.additionalInfoJob.jobWaitTime : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.totalMiles ? trip.job.additionalInfoJob.totalMiles : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.jobMinutes ? trip.job.additionalInfoJob.jobMinutes : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.jobTotalMiles ? trip.job.additionalInfoJob.jobTotalMiles.toFixed(2) : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.jobTotalTime ? trip.job.additionalInfoJob.jobTotalTime.toFixed(2) : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.surchargeMiles && trip.job.additionalInfoJob.jobTotalMiles ? (trip.job.additionalInfoJob.jobTotalMiles + trip.job.additionalInfoJob.surchargeMiles).toFixed(2) : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.surchargeMinutes && trip.job.additionalInfoJob.jobTotalTime ? (trip.job.additionalInfoJob.jobTotalTime + trip.job.additionalInfoJob.surchargeMinutes).toFixed(2) : ' ',
        trip.companyNote ? trip.companyNote : ' ',
        trip.billerNote ? trip.billerNote : ' ',
        trip.dispatchNoteTwo ? trip.dispatchNoteTwo : ' ',
        acceptedDate ? acceptedDate : ' ',
        trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobAccepted && trip.job.trackInfoJob.jobAccepted.time ? [trip.job.trackInfoJob.jobAccepted.coords[0], trip.job.trackInfoJob.jobAccepted.coords[1]].toString() : ' ',
        pickupDate ? pickupDate : ' ',
        trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobArrived && trip.job.trackInfoJob.jobArrived.time ? [trip.job.trackInfoJob.jobArrived.coords[0], trip.job.trackInfoJob.jobArrived.coords[1]].toString() : ' ',
        arrivedDate ? arrivedDate : ' ',
        trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobStarted && trip.job.trackInfoJob.jobStarted.time ? [trip.job.trackInfoJob.jobStarted.coords[0], trip.job.trackInfoJob.jobStarted.coords[1]].toString() : ' ',
        endDate ? endDate : ' ',
        trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobCompleted && trip.job.trackInfoJob.jobCompleted.time ? [trip.job.trackInfoJob.jobCompleted.coords[0], trip.job.trackInfoJob.jobCompleted.coords[1]].toString() : ' ',
        finishDate ? finishDate : ' ',
        trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobFinished && trip.job.trackInfoJob.jobFinished.time ? [trip.job.trackInfoJob.jobFinished.coords[0], trip.job.trackInfoJob.jobFinished.coords[1]].toString() : " ",
        trip.preSpecialRate ? trip.preSpecialRate : ' ',
        trip.changeReason ? trip.changeReason : ' ',
      ]
      table.push(data)
    });

    exportToCsv(`reports-${moment(date[0]).tz(timezone).format("MM-DD-YYYY")}-${moment(date[1]).tz(timezone).format("MM-DD-YYYY")}.csv`, table);
  }

  driverMonitoringReport(trips, date, timezone) {
    let data;
    let actualPickup, scheduleTime, appointmentTime, actualDropOff, pickupDuration, dropOffDuration;
    let status;
    let dropOffStatus


    const table = [
      [
        "Date",
        "Driver",
        'Patient',
        'Req Pickup',
        'Pick up Arrive',
        'Status(PU)',
        'Duration',
        'Appointment',
        'Dropoff Arrive',
        'Status (Appt)',
        'Duration',
        'Status',
        'Comments'
      ]];
    trips.forEach(trip => {

      if (trip.job) {
        if (trip.scheduleTime) {
          scheduleTime = moment(trip.scheduleTime).tz(timezone).format("HH:mm a");
        }
        if (trip.appointmentTime) {
          appointmentTime = moment(trip.appointmentTime).tz(timezone).format("HH:mm a");
        }
        if (trip.job.trackInfoJob) {
          if (trip.job.trackInfoJob.jobArrived) {
            if (trip.job.trackInfoJob.jobArrived.time) {
              actualPickup = moment(trip.job.trackInfoJob.jobArrived.time).tz(timezone).format("HH:mm a");
              pickupDuration = moment(trip.scheduleTime).diff(moment(trip.job.trackInfoJob.jobArrived.time));
              pickupDuration = (pickupDuration / 60000).toFixed(0);

              const isEarly = moment(trip.scheduleTime).isAfter(moment(trip.job.trackInfoJob.jobArrived.time));
              const diff = pickupDuration
              if (isEarly) {
                if (diff <= 15) {
                  status = "On Time";
                } else {
                  status = "Early";
                }
              } else {
                if (Math.abs(diff) <= 15) {
                  status = "On Time";
                } else {
                  status = "Late";
                }
              }
            }


          }
          if (trip.job.trackInfoJob.jobCompleted) {
            if (trip.job.trackInfoJob.jobCompleted.time) {
              actualDropOff = moment(trip.job.trackInfoJob.jobCompleted.time).tz(timezone).format("HH:mm a");
              dropOffDuration = moment(trip.appointmentTime).diff(moment(trip.job.trackInfoJob.jobCompleted.time))
              dropOffDuration = (dropOffDuration / 60000).toFixed(0)
              const isLate = moment(trip.appointmentTime).isAfter(moment(trip.job.trackInfoJob.jobCompleted.time));
              const diff = dropOffDuration
              if (isLate) {
                if (diff <= 15) {
                  dropOffStatus = "On Time";
                } else {
                  dropOffStatus = "Early";
                }
              } else {
                if (Math.abs(diff) <= 15) {
                  dropOffStatus = "On Time";
                } else {
                  dropOffStatus = "Late";
                }
              }


            }
          }

        }
      }




      data = [
        moment(trip.scheduleTime).tz(timezone).format("MM/DD/YYYY"),
        trip.driver ? trip.driver.displayName : ' ',
        trip.priorityClient ? trip.priorityClient.displayName : ' ',
        scheduleTime ? scheduleTime : ' ',
        actualPickup ? actualPickup : ' ',
        status ? status : ' ',
        pickupDuration ? pickupDuration : ' ',
        appointmentTime ? appointmentTime : ' ',
        actualDropOff ? actualDropOff : ' ',
        dropOffStatus ? dropOffStatus : ' ',
        dropOffDuration ? dropOffDuration : ' ',
        trip.status,
        trip.cancelReason ? trip.cancelReason : ' '
      ]
      table.push(data)
    });


    exportToCsv(`on-scene-report-${moment(date[0]).tz(timezone).format("MM/DD/YYYY") + "-" + moment(date[1]).tz(timezone).format("MM/DD/YYYY")}.csv`, table);
  }

  viewHourFormat(milli) {
    let duration = moment.duration(milli, 'milliseconds');
    return `${Math.floor(duration.asHours())}hr ${duration.minutes()}mins`;
  }

  // outbounding messages
  downloadOutBoundReport(data, date, timezone) {
    const table = [
      [
        "Message",
        "From",
        "To	",
        "Error",
        "Status",
        "Sent Date",
        "Created Date",


      ]];
    data.forEach(message => {
      let data = [
        message.body,
        message.from,
        message.to,
        message.errorMessage ? message.errorMessage : ' ',
        message.status,
        moment(message.dateSent).tz(timezone).format("YYYY/MM/DD"),
        moment(message.dateCreated).tz(timezone).format("YYYY/MM/DD"),

      ]

      table.push(data)
    });

    exportToCsv(`out-bound-report-${moment(date[0]).tz(timezone).format("MM/DD/YYYY") + "-" + moment(date[1]).tz(timezone).format("MM/DD/YYYY")}.csv`, table);
  }

  downloadCTCInvoice(dateRange, data, preFleet, user, timeZone) {
    const table = [
      [
        "Vendor Name",
        "Vendor Tax ID",
        "CTC Trip ID #",
        "Date of Service",
        "Member Last Name",
        "Member First Name",
        "Pick Up Address",
        "Drop Off Address",
        "Requested Arrival Time",
        "Appointment Time",
        "Actual Pickup Arrival Date",
        "Actual Pickup Arrival Time",
        "Actual Drop off Arrival Date",
        "Actual Drop off Arrival Time",
        "Level of Service",
        "Driver Name",
        "Driver License Number",
        "Vehicle VIN",
        "Trip Status",
        "Miles",
        "Wait Time Minutes",
        "Oxygen Provided",
        "Total Cost",
        "Comment",


      ]];
    data.forEach(trip => {

      const losName = levelOfServiceName(trip.companyNote);
      const [firstName, lastName] = trip.priorityClient ? trip.priorityClient.displayName.trim().split(/\s+/) : null;

      let data = [
        // Vendor Name
        user.billingName ? user.billingName : '',
        //Vendor Tax ID,
        user.taxId ? user.taxId : '',
        //CTC Trip ID #,
        trip.tripId,
        //Date of Service,
        moment(trip.scheduleTime).tz(timeZone).format('MM/DD/YY'),
        //Member First Name,
        lastName ? lastName : '',
        //Member Last Name,
        firstName ? firstName : '',
        //Pick Up Address,
        trip.jobOriginAddress,
        //Drop Off Address,
        trip.jobDestinationAddress,
        //Requested Arrival Time,
        moment(trip.scheduleTime).tz(timeZone).format('HH:mm'),
        //Appointment Time,
        moment(trip.appointmentTime).tz(timeZone).format('HH:mm'),
        //Actual Pickup Arrival Date,
        moment(trip.trackInfoJob.jobArrived.time).tz(timeZone).format('MM/DD/YY'),
        //Actual Pickup Arrival Time,
        moment(trip.trackInfoJob.jobArrived.time).tz(timeZone).format('HH:mm'),
        //Actual Drop off Arrival Date,
        moment(trip.trackInfoJob.jobFinished.time).tz(timeZone).format('MM/DD/YY'),
        //Actual Drop off Arrival Time,
        moment(trip.trackInfoJob.jobFinished.time).tz(timeZone).format('HH:mm'),
        //Level of Service,
        // '',
        losName ? losName : preFleet[trip.fleet].losDetails.title,
        //Driver Name,
        trip.driver ? trip.driver.displayName : '',
        //Driver License Number,
        trip.driver ? trip.driver.driverLicenseNumber : '',
        //Vehicle VIN,
        preFleet[trip.fleet].vin,
        //Trip Status,
        trip.status === "finished" ? 'Complete' : 'No Show',
        //Miles,
        trip.milage,
        //Wait Time Minutes,
        '0',
        //Oxygen Provided,
        'False',
        //Total Cost,
        trip.preSpecialRate ? parseFloat(trip.preSpecialRate) : 0,
        //Comment,
        ' ',

      ]

      table.push(data)
    });

    const sheets = {
      "Trips": table,
    };
    exportToExcel(`CTC-Invoice-report-"${moment(dateRange).tz(timeZone).format('MM/DD/YYYY')}.xlsx`, sheets);
  }

  generateTripsReport(data) {

    const trips = data.selectedTrips;
    const timeZone = data.timezone;
    const preCooperates = data.preCooperates;
    const preLevelOfServices = data.preLevelOfServices;
    const table = [[
      "Funding Source",
      "Trip ID",
      "Member Name",
      "Pick-up Address",
      "Drop-Off Address",
      "Phone Number 1",
      "Phone Number 2",
      "Mileage",
      "Schedule Time",
      "Actual Pick-up Time",
      "Appt. Time",
      "Actual Drop-Off Time",
      "Level Of Service",
      "Fare",
      "Driver Name",
      "Notes/Dispatch Notes",
      "Status",
      "On Scene At",
      "Member Onboard At",
      "Finished At",
      "Cancelled At",
      "Cancelled Reason",
      "Confirmed",
      "No Answer",
      "Bad Number",
      "Voicemail",
      "Created At"
    ]];
    for (const trip of trips) {
      let corporateName;
      corporateName = preCooperates &&  preCooperates[trip.cooperate] ? preCooperates[trip.cooperate].displayName : '';

      let appointmentTime;
      if (trip.appointmentTime) {
        appointmentTime = moment(trip.appointmentTime).tz(timeZone).format('MM/DD/YYYY HHmm');
      }
      let scheduleTime;
      if (trip.scheduleTime) {
        scheduleTime = moment(trip.scheduleTime).tz(timeZone).format('MM/DD/YYYY HHmm');
      }

      let driverName;
      if (trip.driver) {
        driverName = trip.driver.displayName;
      }

      let notes;
      // if (trip.note) {
      //   notes = trip.note ? trip.note : 'N/A';
      // }

      if (trip.companyNote) {
        notes = trip.companyNote ? trip.companyNote : 'N/A';
      }

      let actualPickupTime;
      if (trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobStarted) {
        actualPickupTime = moment(trip.job.trackInfoJob.jobStarted.time).tz(timeZone).format('MM/DD/YYYY HHmm');
      }

      let actualDropOffTime;
      if (trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobFinished) {
        actualDropOffTime = moment(trip.job.trackInfoJob.jobFinished.time).tz(timeZone).format('MM/DD/YYYY HHmm');
      }

      let fare;
      if (trip.jobType !== 'cooperate' && trip.preSpecialRate) {
        fare = trip.preSpecialRate;
      }

      if (trip.jobType === 'cooperate' && trip.customerSpecialRate) {
        fare = trip.customerSpecialRate;
      }

      if (!fare) {
        if (trip.job && trip.job.jobFareDetail && trip.job.jobFareDetail.jobFee) {
          fare = trip.job.jobFareDetail.jobFee
        }
      }

      const status = this.getTripStatus(trip);
      const los = trip.los && preLevelOfServices && preLevelOfServices[trip.los] ? preLevelOfServices[trip.los].title : 'N/A';

      let jobAccepted, jobArrived, jobStarted, jobCompleted, jobFinished, jobCancelled;
      if (trip.job && trip.job.trackInfoJob) {
        const jobInfo = trip.job.trackInfoJob;
        jobAccepted = jobInfo.jobAccepted ? moment(jobInfo.jobAccepted.time).tz(timeZone).format('MM/DD/YYYY HHmm') : "";
        jobArrived = jobInfo.jobArrived ? moment(jobInfo.jobArrived.time).tz(timeZone).format('MM/DD/YYYY HHmm') : ""; // On Scene
        jobStarted = jobInfo.jobStarted ? moment(jobInfo.jobStarted.time).tz(timeZone).format('MM/DD/YYYY HHmm') : ""; // Member Onboard
        jobCompleted = jobInfo.jobCompleted ? moment(jobInfo.jobCompleted.time).tz(timeZone).format('MM/DD/YYYY HHmm') : "";
        jobFinished = jobInfo.jobFinished ? moment(jobInfo.jobFinished.time).tz(timeZone).format('MM/DD/YYYY HHmm') : ""; // Finished
        jobCancelled = jobInfo.jobCancelled ? moment(jobInfo.jobCancelled.time).tz(timeZone).format('MM/DD/YYYY HHmm') : "";
      }

      const t = [
        corporateName,
        trip.tripId,
        trip.priorityClient.displayName, //"Member Name"
        trip.jobOriginAddress, //"Job Origin Address"
        trip.jobDestinationAddress, //"Job Destination Address"
        trip.priorityClient.cellPhone, //"Passenger's Phone #",
        trip.priorityClient.contactNumber ? trip.priorityClient.contactNumber : 'N/A', //"Passenger's 2-nd Phone#",
        trip.milage ? trip.milage : 'N/A',
        scheduleTime,
        actualPickupTime ? actualPickupTime : 'N/A',
        appointmentTime,
        actualDropOffTime ? actualDropOffTime : 'N/A',
        los,//trip.tripRequirement,
        fare ? '$' + fare : 'N/A',
        driverName,
        notes,
        status,
        jobArrived,
        jobStarted,
        jobFinished,
        jobCancelled,
        trip.changeReason,
        trip.isConfirmedTrip ? 'Yes' : 'No',
        trip.notAnswer ? 'Yes' : 'No',
        trip.badPhoneNumber ? 'Yes' : 'No',
        trip.isVoiceMail ? 'Yes' : 'No',
        trip.createdAt ? moment(trip.createdAt).tz(timeZone).format('MM/DD/YYYY HHmm') : ''
      ]
      table.push(t);
    }
    exportToCsv(`trips-report-${moment(data.scheduleTime).tz(timeZone).format("MM-DD-YYYY")}-To-${moment(data.endDate).tz(timeZone).format("MM-DD-YYYY")}.csv`, table);
  }

  getTripStatus(trip) {
    if (trip.jobStatus === "pending")
      return "Unassigned"
    if (trip.jobStatus === "arrived")
      return "On Scene"
    if (trip.jobStatus === "started")
      return "Member Onboard"
    else
      return this.capitalize.transform(trip.jobStatus);
  }

  generateCompletedTripReport(data) {
    const { trips, date, timezone } = data
    const table = [
      [
        "driver_name",
        "driver_email",
        "driver_phone",
        "driver_identifier",
        "vehicle_type",
        "vehicle_identifier",
        "vehicle_license_plate",
        "vehicle_operator_information",
        "vehicle_number",
        "customer_name",
        "customer_email",
        "customer_phone",
        "booked_by",
        "booking_agent",
        "affiliate_status",
        "affiliate",
        "ride_id",
        "ride_external_id",
        "ride_startAddr",
        "ride_endAddr",
        "ride_start_coordinate",
        "ride_end_coordinate",
        "ride_createdDate",
        "ride_acceptedDate",
        "ride_pickupDate",
        "ride_estimatedArrivedDate",
        "ride_arrivedDate",
        "ride_startDate",
        "ride_endDate",
        "ride_duration_minutes",
        "ride_miles",
        "ride_waiting_time_minutes",
        "ride_passengers",
        "ride_coupon_code",
        "ride_dispatcher_notes",
        "ride_drivers_notes",
        "service_type",
        "account_name",
        "account_id",
        "ride_status",
        "driver_rating_stars",
        "driver_rating_message",
        "rider_rating_stars",
        "rider_rating_message",
        "ride_chat_history",
        "ride_surcharge_breakdown",
        "ride_transaction_currency",
        "ride_transaction_total",
        "ride_transaction_subtotal",
        "ride_transaction_tax",
        "ride_transaction_tolls",
        "ride_transaction_waiting",
        "ride_transaction_other_surcharge",
        "ride_transaction_tip",
        "ride_transaction_discount",
        "ride_transaction_processingFees",
        "ride_transaction_refunded",
        "ride_transaction_credited",
        "ride_transaction_affiliate_share",
        "ride_transaction_dashride_fee",
        "ride_transaction_company_net",
        "ride_transaction_driverCommission",
        "ride_transaction_paymentMethod",
        "ride_bank_deposit_id",
        "ride_prepaid",
        "ride_prepaid_charged",
        "ride_prepaid_net",
        "ride_prepaid_refunded",
        "extraField_reason_for_transport",
        "extraField_patients_date_of_birth",
        "extraField_special_instructions:",
        "extraField_destination/office_suite#",
        "extraField_patients_cell_#",
        "extraField_facilities_#",
        "extraField_passengers",
        "extraField_appointment_type",
        "extraField_if_transport_by_wheelchair:",
        "extraField_medical_office_name:",
        "extraField_appointment_time",
        "extraField_date_requesting_transport:",
        "extraField_patients_weight",
        "extraField_facility_contact_number",
        "extraField_doctor/hospital_information",
        "extraField_special_instructions_for_driver",
        "extraField_special_instructions(i.e)_patient's_weight",
        "extraField_patients_weight",
        "extraField_patient_weight",
        "extraField_appointment_suite_number",
        "extraField_covid-19",
        "extraField_date_of_birth",
        "extraField_flight_#",
        "extraField_departure_time",
        "extraField_arrival_time"
      ]];
    trips.forEach(trip => {
      let created, acceptedDate, pickupDate, arrivedDate, startedDate, endDate, rideDuration, rideWaitTime, totalFare, rideMiles, vehicleType = '';
      if (trip) {
        if (trip.job) {
          if (trip.job.created) {
            created = moment(trip.job.created).tz(timezone).format("MMM DD, YYYY HH:mm A");
          }

          if (trip.job.trackInfoJob) {
            if (trip.job.trackInfoJob.jobAccepted) {
              if (trip.job.trackInfoJob.jobAccepted.time) {
                acceptedDate = moment(trip.job.trackInfoJob.jobAccepted.time).tz(timezone).format("MMM DD, YYYY HH:mm A");
              }
            }

            if (trip.job.trackInfoJob.jobArrived) {
              if (trip.job.trackInfoJob.jobArrived.time) {
                pickupDate = moment(trip.job.trackInfoJob.jobArrived.time).tz(timezone).format("MMM DD, YYYY HH:mm A");
              }
            }

            if (trip.job.trackInfoJob.jobStarted) {
              if (trip.job.trackInfoJob.jobStarted.time) {
                arrivedDate = moment(trip.job.trackInfoJob.jobStarted.time).tz(timezone).format("MMM DD, YYYY HH:mm A");
              }
            }

            if (trip.job.trackInfoJob.jobStarted) {
              if (trip.job.trackInfoJob.jobStarted.time) {
                startedDate = moment(trip.job.trackInfoJob.jobStarted.time).tz(timezone).format("MMM DD, YYYY HH:mm A");
              }
              if (trip.job.trackInfoJob.jobStarted.duration) {
                rideWaitTime = trip.job.trackInfoJob.jobStarted.duration.toFixed(0);
              }
            }

            if (trip.job.trackInfoJob.jobCompleted) {
              if (trip.job.trackInfoJob.jobCompleted.time) {
                endDate = moment(trip.job.trackInfoJob.jobCompleted.time).tz(timezone).format("MMM DD, YYYY HH:mm A");
              }
              if (trip.job.trackInfoJob.jobCompleted.duration) {
                rideDuration = trip.job.trackInfoJob.jobCompleted.duration.toFixed(0);
              }
              if (trip.job.trackInfoJob.jobCompleted.distance) {
                rideMiles = trip.job.trackInfoJob.jobCompleted.distance.toFixed(1);
                if (trip.job.trackInfoJob.jobCompleted.actualMilage) {
                  rideMiles = trip.job.trackInfoJob.jobCompleted.actualMilage.toFixed(1);
                }
              }
            }



          }


          if (trip.job.jobFareDetail) {
            if (trip.job.jobFareDetail.jobFee) {
              totalFare = trip.job.jobFareDetail.jobFee.toFixed(2);
            }
          }
          if (trip.tripRequirement) {
            vehicleType = trip.tripRequirement
          }

        }


        const t = [
          trip.driver && trip.driver.displayName ? trip.driver.displayName : '',
          trip.driver && trip.driver.email ? trip.driver.email : '',
          trip.driver && trip.driver.contactNumber ? trip.driver.contactNumber : '',
          '',
          vehicleType ? vehicleType : ' ',
          '',
          '',
          '',
          '',
          trip.priorityClient && trip.priorityClient.displayName ? trip.priorityClient.displayName : '',
          trip.priorityClient && trip.priorityClient.email ? trip.priorityClient.email : '',
          trip.priorityClient && trip.priorityClient.contactNumber,
          trip.createdBy,
          '',
          'in-house',
          '',
          trip.tripId ? trip.tripId : '',
          trip.rawId ? trip.rawId : '',
          trip.jobOriginAddress ? trip.jobOriginAddress : '',
          trip.jobDestinationAddress ? trip.jobDestinationAddress : '',
          "[" + trip.jobOriginLatitude + "," + trip.jobOriginLongitude + "]",
          "[" + trip.jobDestinationLatitude + "," + trip.jobDestinationLongitude + "]",
          created,
          acceptedDate,
          pickupDate,
          '',
          arrivedDate,
          startedDate,
          endDate,
          rideDuration,
          rideMiles,
          rideWaitTime,
          1 + trip.noOfEscorts,
          '',
          trip.companyNote,
          trip.driverNote,
          vehicleType,
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          'usd',
          totalFare,
          totalFare,
          '0.00',
          '0.00',
          '0.00',
          '0.00',
          '0.00',
          '0.00',
          '0.00',
          '0.00',
          '0.00',
          '0.00',
          '0.00',
          totalFare,
          '0.00',
          'invoice',
          '',
          'no',
          '0.00',
          '0.00',
          '0.00',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          ''
        ]
        table.push(t)
      }




    });
    exportToCsv(`reports-${date}.csv`, table);
  }

  generatePassengerReport(data) {
    const { trips, corporate, driver, vehicle, timezone } = data;
    const myTrips = JSON.parse(JSON.stringify(trips));
    myTrips.sort((a, b) => a.priorityClient.displayName.localeCompare(b.priorityClient.displayName)); // ASC

    const table = [[
      "Id",
      "Passenger's First Name",
      "Passenger's Last Name",
      "Passenger DOB",
      "Schedule Time",
      "Appointment Time",
      "Gender",
      "Weight",
      "Passenger's Phone #",
      "Passenger's 2-nd Phone#",
      "Passenger's Address",
      "Passenger's 2-nd Address",
      "Active (Y/N)",
      "Email	On Hold (Y/N)",
      "Need Attendant (Y/N)",
      "Emergency Name",
      "Emergency Name", "Emergency Phone",
      "Payer",
      "Payer Name",
      "Payer Address",
      "Payer Suit #",
      "Payer Email",
      "Payer Fax #",
      "Payer Contact Person",
      "Payer Contact Person's Phone Number",
      "Payer Phone Ext #",
      "Active Payer (Y/N)",
      "Payer Invoice Periodicity"
    ]];
    let privatePay = myTrips.filter(trip => {
      if (corporate) {
        if (trip.jobType !== 'cooperate') {
          return false;
        }
        if (trip.cooperate && trip.cooperate._id.toString() !== corporate) {
          return false;
        }
      }
      if (driver) {
        if (trip.driver && trip.driver._id.toString() !== driver) {
          return false;
        }
      }
      if (vehicle) {
        if (trip.tripRequirement !== vehicle) {
          return false;
        }
      }
      return true;
    })
    for (const trip of privatePay) {

      // if (this.selectedCooperate) {
      //   if (trip.jobType !== 'cooperate') {
      //     continue;
      //   }
      //   if (trip.cooperate && trip.cooperate._id.toString() !== this.selectedCooperate){
      //     continue;
      //   }
      // }
      let forTrip;
      if (trip.jobType !== 'cooperate') {
        forTrip = trip.companyType === "" ? "Cab Dispatch" : getBrokersList[trip.companyType];
      }

      if (trip.jobType === 'cooperate') {
        forTrip = trip.cooperate ? trip.cooperate.displayName : "N/A"
      }

      let appointmentTime;
      if (trip.appointmentTime) {
        appointmentTime = moment(trip.appointmentTime).tz(timezone).format('MM/DD/YYYY HHmm');
      }
      let scheduleTime;
      if (trip.scheduleTime) {
        scheduleTime = moment(trip.scheduleTime).tz(timezone).format('MM/DD/YYYY HHmm');
      }
      let name = trip.priorityClient.displayName.split(' ');
      const t = [
        trip.tripId,
        name[0], //"Passenger's First Name",
        name[1] ? name[1] : 'N/A', //"Passenger's Last Name",
        trip.dob, //"Passenger DOB",
        scheduleTime,
        appointmentTime,
        "---", //"Gender",
        trip.weight, //"Weight",
        trip.priorityClient.cellPhone, //"Passenger's Phone #",
        trip.priorityClient.contactNumber, //"Passenger's 2-nd Phone#",
        trip.jobOriginAddress, //"Passenger's Address",
        "---", //"Passenger's 2-nd Address",
        "---", //"Active (Y/N)",
        trip.priorityClient.email, //"Email	On Hold (Y/N)",
        "---", //"Need Attendant (Y/N)",
        "---", //"Emergency Name",
        "---", //"Emergency Name",
        "---", //"Emergency Phone",
        forTrip, //"Payer",
        "---", //"Payer Name",
        "---", //"Payer Address",
        "---", //"Payer Suit #",
        "---", //"Payer Email",
        "---", //"Payer Fax #",
        "---", //"Payer Contact Person",
        "---", //"Payer Contact Person's Phone Number",
        "---", //"Payer Phone Ext #",
        "TRUE", //"Active Payer (Y/N)",
        "Everyday", //"Payer Invoice Periodicity"
      ]
      table.push(t);
    }
    exportToCsv(`rns-report-${moment().format("MM-DD-YYYY")}.csv`, table);
  }

  generateFinishedReport(data) {
    const { trips, date, timezone } = data
    const table = [
      [
        'Member Name',
        'Member Phone',
        'Member Email',
        "driver_name",
        "driver_email",
        "driver_phone",
        'Trip ID',
        'Raw ID',
        'Broker',
        'Vehicle',
        'Pickup Address',
        'Dropoff Address',
        'Pickup Coordinates',
        'Dropoff Coordinates',
        'Pickup Time',
        'Dropoff Time',
        'Total Miles',
        'Accepted time',
        'Accepted Duration',
        'Accepted Distance',
        'Accepted Coordinates',
        'Started Time',
        'Started Duration',
        'Started Distance',
        'Started Coordinates',
        'Arrived Time',
        'Arrived Duration',
        'Arrived Distance',
        'Arrived Coordinates',
        'Completed timeZone',
        'Completed Duration',
        'Completed Distance',
        'Completed Coordinates',
        'Finished',
        'Finished Duration',
        'Finished Distance',
        'Finished Coordinates',
      ]];
    trips.forEach(trip => {
      let scheduleTime, appointmentTime, acceptedTime, startedTime, arrivedTime, completedTime, finishedTime, rideMiles, vehicleType = '';
      if (trip) {
        if (trip.job) {
          if (trip.scheduleTime) {
            scheduleTime = moment(trip.scheduleTime).tz(timezone).format("MMM DD, YYYY HH:mm A");
          }
          if (trip.appointmentTime) {
            appointmentTime = moment(trip.appointmentTime).tz(timezone).format("MMM DD, YYYY HH:mm A");
          }

          if (trip.job.trackInfoJob) {
            if (trip.job.trackInfoJob.jobAccepted) {
              if (trip.job.trackInfoJob.jobAccepted.time) {
                acceptedTime = moment(trip.job.trackInfoJob.jobAccepted.time).tz(timezone).format("MMM DD, YYYY HH:mm A");
              }
            }
            if (trip.job.trackInfoJob.jobStarted) {
              if (trip.job.trackInfoJob.jobStarted.time) {
                startedTime = moment(trip.job.trackInfoJob.jobStarted.time).tz(timezone).format("MMM DD, YYYY HH:mm A");
              }
            }

            if (trip.job.trackInfoJob.jobArrived) {
              if (trip.job.trackInfoJob.jobArrived.time) {
                arrivedTime = moment(trip.job.trackInfoJob.jobArrived.time).tz(timezone).format("MMM DD, YYYY HH:mm A");
              }
            }
            if (trip.job.trackInfoJob.jobCompleted) {
              if (trip.job.trackInfoJob.jobCompleted.time) {
                completedTime = moment(trip.job.trackInfoJob.jobCompleted.time).tz(timezone).format("MMM DD, YYYY HH:mm A");
              }
              if (trip.job.trackInfoJob.jobCompleted.distance) {
                rideMiles = trip.job.trackInfoJob.jobCompleted.distance.toFixed(1);
                if (trip.job.trackInfoJob.jobCompleted.actualMilage) {
                  rideMiles = trip.job.trackInfoJob.jobCompleted.actualMilage.toFixed(1);
                }
              }
            }

            if (trip.job.trackInfoJob.jobFinished) {
              if (trip.job.trackInfoJob.jobFinished.time) {
                finishedTime = moment(trip.job.trackInfoJob.jobFinished.time).tz(timezone).format("MMM DD, YYYY HH:mm A");
              }
            }
          }
          if (trip.tripRequirement) {
            vehicleType = trip.tripRequirement
          }

        }


        const t = [
          trip.priorityClient && trip.priorityClient.displayName ? trip.priorityClient.displayName : '',
          trip.priorityClient && trip.priorityClient.contactNumber,
          trip.priorityClient && trip.priorityClient.email ? trip.priorityClient.email : '',
          trip.driver && trip.driver.displayName ? trip.driver.displayName : '',
          trip.driver && trip.driver.email ? trip.driver.email : '',
          trip.driver && trip.driver.contactNumber ? trip.driver.contactNumber : '',
          trip.tripId ? trip.tripId : '',
          trip.rawId ? trip.rawId : '',
          trip.companyType ? trip.companyType : trip.cooperate.displayName,
          vehicleType ? vehicleType : ' ',
          trip.jobOriginAddress ? trip.jobOriginAddress : '',
          trip.jobDestinationAddress ? trip.jobDestinationAddress : '',
          "[" + trip.jobOriginLatitude + "," + trip.jobOriginLongitude + "]",
          "[" + trip.jobDestinationLatitude + "," + trip.jobDestinationLongitude + "]",
          scheduleTime,
          appointmentTime,
          trip.milage,
          acceptedTime,
          trip.job.trackInfoJob.jobAccepted.duration,
          trip.job.trackInfoJob.jobAccepted.distance,
          "[" + trip.job.trackInfoJob.jobAccepted.coords[0] + trip.job.trackInfoJob.jobAccepted.coords[1] + "]",
          startedTime,
          trip.job.trackInfoJob.jobStarted.duration,
          trip.job.trackInfoJob.jobStarted.distance,
          "[" + trip.job.trackInfoJob.jobStarted.coords[0] + trip.job.trackInfoJob.jobStarted.coords[1] + "]",
          arrivedTime,
          trip.job.trackInfoJob.jobArrived.duration,
          trip.job.trackInfoJob.jobArrived.distance,
          "[" + trip.job.trackInfoJob.jobArrived.coords[0] + trip.job.trackInfoJob.jobArrived.coords[1] + "]",
          completedTime,
          trip.job.trackInfoJob.jobCompleted.duration,
          trip.job.trackInfoJob.jobCompleted.distance,
          "[" + trip.job.trackInfoJob.jobCompleted.coords[0] + trip.job.trackInfoJob.jobCompleted.coords[1] + "]",
          finishedTime,
          trip.job.trackInfoJob.jobFinished.duration,
          trip.job.trackInfoJob.jobFinished.distance,
          "[" + trip.job.trackInfoJob.jobFinished.coords[0] + trip.job.trackInfoJob.jobFinished.coords[1] + "]",

        ]
        table.push(t)
      }

    })
    exportToCsv(`Completed-${date}.csv`, table);

  }


  // --- Driver Log MTM---
  downloaMTMClaimFile(data) {
    const { trips, date, timezone, preFleet } = data;
    const table = []
    trips.forEach((trip) => {
      let t = [
        trip.tripId,
        trip.driver && trip.driver.driverLicenseNumber ? trip.driver.driverLicenseNumber : '',
        trip.fleet ? preFleet[trip.fleet].vin : '',
        trip.scheduleTime ? moment(trip.scheduleTime).tz(timezone).format('h:mm A') : '',

        trip.trackInfoJob && trip.trackInfoJob.jobArrived && trip.trackInfoJob.jobArrived.time ? moment(trip.trackInfoJob.jobArrived.time).tz(timezone).format('h:mm A') : '',
        trip.trackInfoJob && trip.trackInfoJob.jobStarted && trip.trackInfoJob.jobStarted.time ? moment(trip.trackInfoJob.jobStarted.time).tz(timezone).format('h:mm A') : '',
        trip.trackInfoJob && trip.trackInfoJob.jobFinished && trip.trackInfoJob.jobFinished.time ? moment(trip.trackInfoJob.jobFinished.time).tz(timezone).format('h:mm A') : '',
        'M'
      ]
      table.push(t)
    })
    exportToCsv(`MTM-Claim-File"${date}.csv`, table);
  }

  downloaMTMClaimFileV2(data) {
    const { trips, date, timezone, preFleet } = data;
    const table = [
      [
        'ID',
        "Driver",
        "Vehicle",
        "ScheduledPickupTime",

        "ReportedPickupArriveTime",
        "ReportedPickupPerformTime",
        "ScheduledDropoffTime",
        "ReportedDropoffArriveTime",

        "ReportedDropoffPerformTime",
        "TripLogSignature"
      ]];

    trips.forEach((trip) => {
      if (trip.trackInfoJob) {
        const trackInfo = trip.trackInfoJob
        let row = [
          trip.tripId,
          trip.driver && trip.driver.driverLicenseNumber ? trip.driver.driverLicenseNumber : '',
          trip.fleet ? preFleet[trip.fleet].vin : '',
          trip.scheduleTime ? moment(trip.scheduleTime).tz(timezone).format('hh:mm A') : '',
          trackInfo.jobArrived && trackInfo.jobArrived.time ? moment(trackInfo.jobArrived.time).tz(timezone).format('hh:mm A') : '',
          trackInfo.jobStarted && trackInfo.jobStarted.time ? moment(trackInfo.jobStarted.time).tz(timezone).format('hh:mm A') : '',
          trip.appointmentTime ? moment(trip.appointmentTime).tz(timezone).format('hh:mm A') : '',
          trackInfo.jobCompleted && trackInfo.jobCompleted.time ? moment(trackInfo.jobCompleted.time).tz(timezone).format('hh:mm A') : '',
          trackInfo.jobFinished && trackInfo.jobFinished.time ? moment(trackInfo.jobFinished.time).tz(timezone).format('hh:mm A') : '',
          'Y'
        ]
        table.push(row)
      }

    })
    const sheets = {
      "Trips": table,
    };
    exportToExcel(`MTM-Claim-File"${date}.xlsx`, sheets);
  }


  downloadInvoice(payload, selectedCompany, dateRange, timezone) {
    const table = [
      [
        "Bill To",
        "Company Alias ",
        "Completed Fee",
        "Cancelled Fee",
        "Pending Fee",
        "Discount Label",
        "Discount",
        "Arrears Label",
        "Arrears",
        "Dispatch Month Day",
        "Due Day",
      ]];
    let data = [
      payload.billTo,
      payload.alias,
      payload.completedFee,
      payload.cancelledFee,
      payload.pendingFee,
      payload.discountType,
      payload.discount,
      payload.arrearsType,
      payload.arrearsFee,
      payload.dispatchDate,
      payload.dueDay,
    ]

    table.push(data)

    exportToCsv(`${cleanUpSpaces(selectedCompany.displayName)}-${moment(dateRange[0]).tz(timezone).format("MM/DD/YYYY") + "-" + moment(dateRange[1]).tz(timezone).format("MM/DD/YYYY")}-invoice.csv`, table);
  }

  downloadFarmoutTripsReport(data) {
    const { trips, date, timezone } = data

    const table = [
      [
        'ID',
        'Farmout Id',
        'Member Name',
        "Broker",
        "Vehicle",
        "Driver",
        'Pickup Address',
        'Pickup Time',
        'DropOff Address',
        'DropOff Time',
        "Miles",
        "Escorts",
        "Phone Number",
        "Contact Number",
        "Status",
        "BSR",
        'Tip',
        "Fare",
      ]];

    trips.forEach((trip) => {
      let row = [
        trip.tripId,
        trip.farmout ? trip.farmout.requestId : '',
        trip.priorityClient && trip.priorityClient.displayName ? trip.priorityClient.displayName : '',
        trip.cooperate ? trip.cooperate.displayName : '',
        trip.tripRequirement ? trip.tripRequirement : '',
        trip.driver ? trip.driver.displayName : ' ',
        trip.jobOriginAddress,
        trip.scheduleTime ? moment(trip.scheduleTime).tz(timezone).format('hh:mm A') : '',
        trip.jobDestinationAddress,
        trip.appointmentTime ? moment(trip.appointmentTime).tz(timezone).format('hh:mm A') : '',
        trip.milage,
        trip.noOfEscorts,
        trip.priorityClient ? trip.priorityClient.cellPhone : ' ',
        trip.priorityClient ? trip.priorityClient.contactNumber : ' ',
        trip.status,
        trip.preSpecialRate,
        trip.job && trip.job.jobFareDetail ? trip.job.jobFareDetail.tip : ' ',
        trip.job && trip.job.jobFareDetail ? trip.job.jobFareDetail.jobFee : ' ',
      ]
      table.push(row);
    });

    const sheets = {
      "Trips": table,
    };
    exportToExcel(`farmout-trips"${date}.xlsx`, sheets);
  }

  downloadMoneyForBuckReport(data, date, timezone, source) {
    let type;
    if (source == 'Driver') {
      type = source
    }
    else {
      type = source
    }

    const table = [
      [
        type,
        "Trips",
        "Loaded Miles",
        "Dead Miles",
        "Incentive",
      ]];
    data.forEach(res => {
      let data = [
        res.driver ? res.driver.displayName : ' ',
        res.total,
        (res.loadedMiles).toFixed(2),
        (res.deadMiles).toFixed(2),
        "$" + (res.totalInc).toFixed(2)
      ]

      table.push(data)
    });

    exportToCsv(`miles-for-buck-report-${moment(date[0]).tz(timezone).format("MM/DD/YYYY") + "-" + moment(date[1]).tz(timezone).format("MM/DD/YYYY")}.csv`, table);
  }

  generateRawTripReport(trips, date, timezone, preCooperates, preLevelOfServices, preSpaceTypes, preServiceAreas, preFleet, preDrivers) {
    const table = [
      [
        "trip_id",
        "trip_id (Modified)",
        "trip_status",
        "trip_status (Modified)",
        "change_reason",
        'cancel_reason',


        "passenger_name",
        "contact_number",
        "phone_number",
        "client_id",
        "dob",
        "weight",

        "pu_address",
        "pu_address (Modified)",
        "pu_date",
        "pu_date (Modified)",

        "do_address",
        "do_address (Modified)",
        "do_date",
        "do_date (Modified)",

        "trip_miles",
        "trip_miles (Modified)",

        "funding_source",
        "funding_source (Modified)",

        "driver_name",
        "driver_name (Modified)",

        // Cost Center
        "cost_center",

        "fleet",
        "fleet (Modified)",

        "spacetype",
        "spacetype (Modified)",

        "ipa_number",
        "ipa_number (Modified)",

        "authorization_number",
        "authorization_number (Modified)",

        "accepted_time",
        "accepted_time (Modified)",
        "accepted_coords",
        "onscene_time",
        "onscene_time (Modified)",
        "onscene_coords",
        "started_time",
        "started_time (Modified)",
        "started_coords",
        "ended_time",
        "ended_time (Modified)",
        "ended_coords",
        "finished_time",
        "finished_time (Modified)",
        "finished_coords",

        // fare
        "total_fare",
        "total_fare (Modified)",
        "final_fare",

        "base_fare",
        "base_fare (Modified)",
        "base_fare_code",
        "base_fare_code (Modified)",
        "per_mile",
        "per_mile (Modified)",
        "per_mile_code",
        "per_mile_code (Modified)",

        "pu_modifier",
        "pu_modifier (Modified)",
        "do_modifier",
        "do_modifier (Modified)",
        "primary_diagnose",
        "primary_diagnose (Modified)",

        "odometer_begin",
        "odometer_begin (Modified)",
        "odometer_start",
        "odometer_start (Modified)",
        "odometer_end",
        "odometer_end (Modified)",

        "track_id",
        "raw_id",
        "created_at",

        "driver_notes",
        "biller_notes",
        "dispatcher_notes",

        "service_area",
        "level_of_service",


        "dead_miles",
        "dead_minutes",
        "wait_time",
        "trip_miles",
        "trip_time",
        "total_trip_miles",
        "total_trip_time",
        "total_trip_miles_+_dead_miles",
        "total_trip_time_+_dead_minutes",
        "Addon Fare",
        "Modified Addon Fare",
      ]];
    trips.forEach(trip => {
      let totalAddonFare = 0;
      if(trip.addonServices && trip.addonServices.length){
        totalAddonFare = trip.addonServices.reduce((sum, addon) => sum + addon.total, 0)
      }
      const adjustedTrip = trip.adjustmentjob ? trip.adjustmentjob : undefined;
      let adjustmentAddonFare = 0;
      if(adjustedTrip && adjustedTrip.addonServices && adjustedTrip.addonServices.length){
        adjustmentAddonFare = adjustedTrip.addonServices.reduce((sum, addon) => sum + addon.total, 0)
      }
      let acceptedDate, arrivedDate, startedDate, completedDate, finishedDate = ' ';
      let adjustedAcceptedDate, adjustedArrivedDate, adjustedStartedDate, adjustedCompletedDate, adjustedFinishedDate;

      if (trip.job) {
        if (trip.job.trackInfoJob) {
          if (trip.job.trackInfoJob.jobAccepted) {
            if (trip.job.trackInfoJob.jobAccepted.time) {
              acceptedDate = moment(trip.job.trackInfoJob.jobAccepted.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }
          if (trip.job.trackInfoJob.jobArrived) {
            if (trip.job.trackInfoJob.jobArrived.time) {
              arrivedDate = moment(trip.job.trackInfoJob.jobArrived.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }
          if (trip.job.trackInfoJob.jobStarted) {
            if (trip.job.trackInfoJob.jobStarted.time) {
              startedDate = moment(trip.job.trackInfoJob.jobStarted.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }
          if (trip.job.trackInfoJob.jobCompleted) {
            if (trip.job.trackInfoJob.jobCompleted.time) {
              completedDate = moment(trip.job.trackInfoJob.jobCompleted.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }
          if (trip.job.trackInfoJob.jobFinished) {
            if (trip.job.trackInfoJob.jobFinished.time) {
              finishedDate = moment(trip.job.trackInfoJob.jobFinished.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }
        }
      }

      if (adjustedTrip && adjustedTrip.trackInfoJob) {
        if (adjustedTrip.trackInfoJob.jobAccepted) {
          if (adjustedTrip.trackInfoJob.jobAccepted.time) {
            adjustedAcceptedDate = moment(adjustedTrip.trackInfoJob.jobAccepted.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
          }
        }
        if (adjustedTrip.trackInfoJob.jobArrived) {
          if (adjustedTrip.trackInfoJob.jobArrived.time) {
            adjustedArrivedDate = moment(adjustedTrip.trackInfoJob.jobArrived.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
          }
        }
        if (adjustedTrip.trackInfoJob.jobStarted) {
          if (adjustedTrip.trackInfoJob.jobStarted.time) {
            adjustedStartedDate = moment(adjustedTrip.trackInfoJob.jobStarted.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
          }
        }
        if (adjustedTrip.trackInfoJob.jobCompleted) {
          if (adjustedTrip.trackInfoJob.jobCompleted.time) {
            adjustedCompletedDate = moment(adjustedTrip.trackInfoJob.jobCompleted.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
          }
        }
        if (adjustedTrip.trackInfoJob.jobFinished) {
          if (adjustedTrip.trackInfoJob.jobFinished.time) {
            adjustedFinishedDate = moment(adjustedTrip.trackInfoJob.jobFinished.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
          }
        }
      }

      let data = [
        trip.tripId ? trip.tripId : '',
        adjustedTrip && adjustedTrip.tripId ? adjustedTrip.tripId : '',
        trip.status ? trip.status : '',

        adjustedTrip && adjustedTrip.status ? adjustedTrip.status : '',
        trip.changeReason ? trip.changeReason : ' ',
        trip.changeReason.includes('Dry Run') ? 'Dry Run' : '',


        trip.priorityClient && trip.priorityClient.displayName ? trip.priorityClient.displayName : ' ',
        trip.priorityClient && trip.priorityClient.contactNumber ? trip.priorityClient.contactNumber : ' ',
        trip.priorityClient && trip.priorityClient.cellPhone ? trip.priorityClient.cellPhone : ' ',
        trip.priorityClient && trip.priorityClient.clientId ? trip.priorityClient.clientId : ' ',
        trip.priorityClient && trip.priorityClient.dob ? moment(trip.priorityClient.dob).format("MMM DD, YYYY") : '',
        trip.priorityClient && trip.priorityClient.weight ? trip.priorityClient.weight : ' ',

        trip.jobOriginAddress ? trip.jobOriginAddress : ' ',
        adjustedTrip && adjustedTrip.jobOriginAddress ? adjustedTrip.jobOriginAddress : ' ',
        trip.scheduleTime ? moment(trip.scheduleTime).tz(timezone).format("MMM DD, YYYY : HH:mm") : '',
        adjustedTrip && adjustedTrip.scheduleTime ? moment(adjustedTrip.scheduleTime).tz(timezone).format("MMM DD, YYYY : HH:mm") : '',

        trip.jobDestinationAddress ? trip.jobDestinationAddress : '',
        adjustedTrip && adjustedTrip.jobDestinationAddress ? adjustedTrip.jobDestinationAddress : '',
        trip.appointmentTime ? moment(trip.appointmentTime).tz(timezone).format("MMM DD, YYYY : HH:mm") : '',
        adjustedTrip && adjustedTrip.appointmentTime ? moment(adjustedTrip.appointmentTime).tz(timezone).format("MMM DD, YYYY : HH:mm") : '',

        trip.milage ? trip.milage : ' ',
        adjustedTrip && adjustedTrip.milage ? adjustedTrip.milage : ' ',

        trip.cooperate && preCooperates[trip.cooperate] ? preCooperates[trip.cooperate].displayName : ' ',
        adjustedTrip && adjustedTrip.cooperate && preCooperates[adjustedTrip.cooperate] ? preCooperates[adjustedTrip.cooperate].displayName : '',

        trip.driver && preDrivers[trip.driver] ? preDrivers[trip.driver].displayName : '',
        adjustedTrip && adjustedTrip.driver && preDrivers[adjustedTrip.driver] ? preDrivers[adjustedTrip.driver].displayName : '',
        // Cost Center
        trip.driver && preDrivers[trip.driver] ? preDrivers[trip.driver].costCenter : '',

        trip.fleet && preFleet[trip.fleet] ? `${preFleet[trip.fleet].setiDecall} - ${preFleet[trip.fleet].driverCarModel} - ${preFleet[trip.fleet].driverCarNumber}` : '',
        adjustedTrip && adjustedTrip.fleet && preFleet[adjustedTrip.fleet] ? `${preFleet[adjustedTrip.fleet].setiDecall} - ${preFleet[adjustedTrip.fleet].driverCarModel} - ${preFleet[adjustedTrip.fleet].driverCarNumber}` : '',

        trip.spaceType && preSpaceTypes[trip.spaceType] ? preSpaceTypes[trip.spaceType].title : ' ',
        adjustedTrip && preSpaceTypes[adjustedTrip.spaceType] ? preSpaceTypes[adjustedTrip.spaceType].title : ' ',

        trip.ipa ? trip.ipa : ' ',
        adjustedTrip && adjustedTrip.ipa ? adjustedTrip.ipa : ' ',

        trip.authorizationNumber ? trip.authorizationNumber : ' ',
        adjustedTrip && adjustedTrip.authorizationNumber ? adjustedTrip.authorizationNumber : ' ',

        // Onway
        acceptedDate ? acceptedDate : ' ',
        adjustedAcceptedDate ? adjustedAcceptedDate : ' ',
        trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobAccepted && trip.job.trackInfoJob.jobAccepted.time ? [trip.job.trackInfoJob.jobAccepted.coords[0], trip.job.trackInfoJob.jobAccepted.coords[1]].toString() : ' ',

        // Onscene
        arrivedDate ? arrivedDate : ' ',
        adjustedArrivedDate ? adjustedArrivedDate : ' ',
        trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobArrived && trip.job.trackInfoJob.jobArrived.time ? [trip.job.trackInfoJob.jobArrived.coords[0], trip.job.trackInfoJob.jobArrived.coords[1]].toString() : ' ',

        // Member Onboard
        startedDate ? startedDate : '',
        adjustedStartedDate ? adjustedStartedDate : '',
        trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobStarted && trip.job.trackInfoJob.jobStarted.time ? [trip.job.trackInfoJob.jobStarted.coords[0], trip.job.trackInfoJob.jobStarted.coords[1]].toString() : ' ',

        // Completed
        completedDate ? completedDate : ' ',
        adjustedCompletedDate ? adjustedCompletedDate : ' ',
        trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobCompleted && trip.job.trackInfoJob.jobCompleted.time ? [trip.job.trackInfoJob.jobCompleted.coords[0], trip.job.trackInfoJob.jobCompleted.coords[1]].toString() : ' ',

        // Finished
        finishedDate ? finishedDate : ' ',
        adjustedFinishedDate ? adjustedFinishedDate : ' ',
        trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobFinished && trip.job.trackInfoJob.jobFinished.time ? [trip.job.trackInfoJob.jobFinished.coords[0], trip.job.trackInfoJob.jobFinished.coords[1]].toString() : " ",

        trip.preSpecialRate ? trip.preSpecialRate : '',
        adjustedTrip && adjustedTrip.preSpecialRate ? adjustedTrip.preSpecialRate : '',
        adjustedTrip && adjustedTrip.preSpecialRate ? adjustedTrip.preSpecialRate :  trip.preSpecialRate,

        trip.jobfareformula && trip.jobfareformula.baseFare && trip.jobfareformula.baseFare.fare ? trip.jobfareformula.baseFare.fare : '',
        adjustedTrip && adjustedTrip.baseFare ? adjustedTrip.baseFare : '',

        trip.jobfareformula && trip.jobfareformula.baseFareCode ? trip.jobfareformula.baseFareCode : '',
        adjustedTrip && adjustedTrip.baseFareCode ? adjustedTrip.baseFareCode : '',

        trip.jobfareformula && trip.jobfareformula.perMile ? trip.jobfareformula.perMile : '',
        adjustedTrip && adjustedTrip.perMile ? adjustedTrip.perMile : '',

        trip.jobfareformula && trip.jobfareformula.perMileCode ? trip.jobfareformula.perMileCode : '',
        adjustedTrip && adjustedTrip.perMileCode ? adjustedTrip.perMileCode : '',

        trip.puModifier ? trip.puModifier : '',
        adjustedTrip && adjustedTrip.puModifier ? adjustedTrip.puModifier : '',
        trip.doModifier ? trip.doModifier : '',
        adjustedTrip && adjustedTrip.doModifier ? adjustedTrip.doModifier : '',

        trip.primaryDiagnosis ? trip.primaryDiagnosis : '',
        adjustedTrip && adjustedTrip.primaryDiagnosis ? adjustedTrip.primaryDiagnosis : '',

        trip.job && trip.job.odometerBegin ? trip.job.odometerBegin : ' ',
        adjustedTrip && adjustedTrip.odometerBegin ? adjustedTrip.odometerBegin : ' ',
        trip.job && trip.job.odometerStart ? trip.job.odometerStart : ' ',
        adjustedTrip && adjustedTrip.odometerStart ? adjustedTrip.odometerStart : ' ',
        trip.job && trip.job.odometerStop ? trip.job.odometerStop : ' ',
        adjustedTrip && adjustedTrip.odometerStop ? adjustedTrip.odometerStop : ' ',

        trip.trackId ? trip.trackId : ' ',
        trip.rawId ? trip.rawId : ' ',
        trip.createdAt ? moment(trip.createdAt).tz(timezone).format("MMM DD, YYYY : HH:mm") : '',

        trip.companyNote ? trip.companyNote : ' ',
        trip.billerNote ? trip.billerNote : ' ',
        trip.dispatchNoteTwo ? trip.dispatchNoteTwo : ' ',

        preServiceAreas[trip.serviceArea] ? preServiceAreas[trip.serviceArea].name : ' ',
        preLevelOfServices && preLevelOfServices[trip.los] ? preLevelOfServices[trip.los].title : ' ',

        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.surchargeMiles ? trip.job.additionalInfoJob.surchargeMiles : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.surchargeMinutes ? trip.job.additionalInfoJob.surchargeMinutes : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.jobWaitTime ? trip.job.additionalInfoJob.jobWaitTime : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.totalMiles ? trip.job.additionalInfoJob.totalMiles : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.jobMinutes ? trip.job.additionalInfoJob.jobMinutes : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.jobTotalMiles ? trip.job.additionalInfoJob.jobTotalMiles.toFixed(2) : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.jobTotalTime ? trip.job.additionalInfoJob.jobTotalTime.toFixed(2) : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.surchargeMiles && trip.job.additionalInfoJob.jobTotalMiles ? (trip.job.additionalInfoJob.jobTotalMiles + trip.job.additionalInfoJob.surchargeMiles).toFixed(2) : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.surchargeMinutes && trip.job.additionalInfoJob.jobTotalTime ? (trip.job.additionalInfoJob.jobTotalTime + trip.job.additionalInfoJob.surchargeMinutes).toFixed(2) : ' ',
        totalAddonFare,
        adjustmentAddonFare
      ]
      table.push(data)
    });

    exportToCsv(`raw-report-${moment(date[0]).tz(timezone).format("MM-DD-YYYY")}-${moment(date[1]).tz(timezone).format("MM-DD-YYYY")}.csv`, table);
  }

  // ---csv----
   generateDriverCSV(data, preFundingSource, selectedDriver , dateRange) {

    const table = [
      [
        "Date",
        "Driver",
        "Member",
        "Mileage",
        "Amount",
        "Funding Source",
      ]
      ];


      data.forEach((item:any) => {
         let temp = [
        moment(item.scheduleTime).format('MM/DD/YYYY'),
        selectedDriver.displayName,
        item.priorityClient.displayName,
        item.milage,
        item.preSpecialRate,
        preFundingSource[item.cooperate].displayName
         ]
      table.push(temp)
    });
    exportToCsv(`${selectedDriver.displayName}-report-${moment(dateRange[0]).format('MM/DD/YYYY') + '-' + moment(dateRange[1]).format('MM/DD/YYYY')}.csv`, table);
    // this.excelService.setCombinedFirstRowWithFontSize(date, table, `drivers-report-${moment().format("MM-DD-YYYY")}`);
  }
  getVehicleMaintenanceReport(data: any[]) {
    const table = [
      [
        "Driver",
        "Workshop",
        "Service Type",
        "Odometer",
        "Next Odometer",
        "Cost",
        "Service Name(s)",
        "Notes",
        "Receipt URL",
        "Fleet Car Number",
        "Date"
      ]
    ];

    for (let item of data) {
      const serviceNames = Array.isArray(item.maintenanceservice)
        ? item.maintenanceservice.map((s: any) => s.name).join(", ")
        : "";

      const row = [
        item.driver ? item.driver.displayName : "",
        item.mechanicWorkshop || "",
        item.type || "",
        item.odometer || "",
        item.nextOdometer || "",
        item.cost || "",
        serviceNames,
        item.notes || "",
        item.receiptImageURL || "",
        item.fleet ? item.fleet.driverCarNumber : "",
        item.created ? moment(item.created).format("MM/DD/YYYY") : ""
      ];

      table.push(row);
    }

    const date = moment().format("YYYY-MM-DD_HH-mm-ss");
    exportToCsv(`vehicle-maintenance-${date}.csv`, table);
  }

  driverEarningsReport(data, dateRange, driver, timeZone) {
    if (data && driver && dateRange) {
      const table1 = [
        [
          'Date Range',
          'Driver Name',
          'Total Revenue',
          'Company Cut(%)',
          'Insurance Charges',
          'App Fee',
          'Other Fee',
          "Driver's Take Home"
        ]
      ]

      let totals = [
        moment(dateRange.startDate).format("MM/DD/YYYY") + '-' + moment(dateRange.endDate).format("MM/DD/YYYY"),
        driver.displayName,
        data.totalAmount ? data.totalAmount.toFixed(2) : 0,
        data.companyFee ? data.companyFee.toFixed(2) : 0,
        data.insuranceFee ? data.insuranceFee.toFixed(2) : 0,
        data.appFee ? data.appFee.toFixed(2) : 0,
        data.otherFee ? data.otherFee.toFixed(2) : 0,
        data.driverEarnings ? data.driverEarnings.toFixed(2) : 0,
      ]
      table1.push(totals)


      const table2 = [
        [
          'Trip ID',
          'Date',
          'Pickup Address',
          'Dropoff Address',
          'Miles',
          'Amount',
        ]
      ]
      if (data.trips && data.trips.length) {
        for (let item of data.trips) {
          if (item) {
            let t = [
              item.tripId,
              item.scheduleTime ? moment(item.scheduleTime).tz(timeZone).format("MM/DD/YYYY") : '',
              item.jobOriginAddress,
              item.jobDestinationAddress,
              item.milage,
              item.preSpecialRate,
            ]
            table2.push(t)
          }
        }
      }
      const sheets = {
        "Totals": table1,
        "Trips": table2,
      };
      exportToExcel("Driver-Earnings.xlsx", sheets);
    }
  }



}


